window.addEventListener("load", () => {
    if (navigator.connection?.saveData || 2 > (navigator.deviceMemory || 4)) {
        console.info("\uD83D\uDCA1 Skipping FrontChat: data saver or low memory");
        return;
    }
    function t() {
        let t = document.createElement("script");
        (t.src = "https://chat-assets.frontapp.com/v1/chat.bundle.js"),
            (t.async = !0),
            (t.onload = () => {
                "function" == typeof window.FrontChat &&
                    window.FrontChat("init", {
                        chatId: "cec40b998f9bdda7438f2d158205e5ab",
                        useDefaultLauncher: !0,
                        shouldShowWindowOnLaunch: !1,
                        shouldExpandOnShowWindow: !1,
                        shouldHideCloseButton: !1,
                        shouldHideExpandButton: !1,
                    });
            }),
            (t.onerror = () => console.error("❌ Failed to load FrontChat")),
            document.head.appendChild(t);
    }
    "requestIdleCallback" in window
        ? requestIdleCallback(t, { timeout: 1e4 })
        : setTimeout(t, 5e3);
});
